module.exports = __webpack_public_path__ + "img/equipment-09@2x.6b4ea128.jpg";